import {useSelector} from 'react-redux';
import {cn} from "@/utils";
import {appSelector} from "../slices/appSlice";
import { matrixSelector } from '../slices/matrixSlice';

const Closing = ({deliveryTimeText, express, currentOptions}) => {
  const {bundle, paymentMethods, priceDisplay} = useSelector(appSelector);
  const { AveryCustom: { client } } = useSelector(matrixSelector);
  const priceSequence = priceDisplay.split('_');

  // Omit closing in B2B context
  if (client) { return (<span></span>); }

  const getAdditionalOrderInformation = () => {
    let identifier, translation = '';

    //We need Drupal.t here to get the translation into Drupal
    if (bundle === 'blank_label') {
      translation = Drupal.t("blank_label_additional_order_information");
      identifier = "blank_label_additional_order_information";
    } else if (bundle === 'custom_printing') {
      translation = Drupal.t("custom_printing_additional_order_information");
      identifier = "custom_printing_additional_order_information";
    }

    if (identifier && translation !== identifier) {
      return translation.trim();
    }

    return false;
  };

  let orderInformation = Drupal.t("All prices incl. tax and if applicable plus shipping costs.");
  if (priceSequence?.[0] === 'net') {
    orderInformation = Drupal.t("All prices excl. tax and if applicable plus shipping costs.");
  }
  const additionalOrderInformation = getAdditionalOrderInformation();
  const showOrderInformationDiv = (orderInformation && orderInformation !== '&nbsp;') || (additionalOrderInformation !== false)
  const hasOutOfStock = currentOptions.some(i => i.is_out_of_stock === true);
  const deliveryInfoText = Drupal.t("Delivery information");
  const hasDeliveryInformation = deliveryInfoText !== "Delivery information";

  return (
    <div className="closing mt-xl">
      <div className="font-medium text-sm bg-neutral-light flex flex-col justify-between mt-xl p-lg py-md gap-y-2xs tablet:font-semibold tablet:p-xl">
        <Choose>
          <When condition={!hasOutOfStock}>
            <div className="flex items-center gap-xs text-status-success-dark">
              <div className="flex items-center w-xl">
                <ft-icon name="check" color="green"></ft-icon>
              </div>
              <div>
                {Drupal.t("In Stock")}
                <If condition={express}>
                  &nbsp;-&nbsp;<span dangerouslySetInnerHTML={{
                  __html: Drupal.t(
                    "Order before 12:00 noon for Next Working Day Delivery"
                  )
                }}>
              </span>
                </If>
              </div>
            </div>
          </When>
          <Otherwise>
            <div className="flex items-center gap-xs text-status-error-dark">
              <div className="flex items-center w-xl">
                <ft-icon name="close" color="red"></ft-icon>
              </div>
              <div>{Drupal.t("Out of Stock")}</div>
            </div>
          </Otherwise>
        </Choose>
        <div className="flex items-center gap-xs">
          <div className="flex items-center w-xl">
              <ft-icon name="time"></ft-icon>
          </div>
          <div>
            {deliveryTimeText}
            <If condition={hasDeliveryInformation}>
              &nbsp;|&nbsp;<span dangerouslySetInnerHTML={{__html: deliveryInfoText}}></span>
            </If>
          </div>
        </div>
        <div className="flex items-center gap-xs">
          <div className="flex items-center w-xl">
            <ft-icon name="truck"></ft-icon>
          </div>
          <div>
            {Drupal.t("Standard shipping 4,90 €")} | {Drupal.t("Free shipping from 49 € (D/AT)")}
          </div>
        </div>
        <If condition={paymentMethods.length > 0}>
          <div className="flex flex-wrap items-center justify-center gap-3xs mt-2xs">
            {paymentMethods.map((method, i) => (
              <div key={'method' + i} className="payment-badge flex items-center rounded bg-white border border-neutral-dark h-3xl p-3xs">
                <ft-icon name={method}></ft-icon>
              </div>
            ))}
          </div>
        </If>
        <If condition={showOrderInformationDiv === true}>
          <div className="w-full mt-sm text-center mb-lg font-normal">
            <If condition={orderInformation && orderInformation !== '&nbsp;'}>
              <div className={cn("text-sm", additionalOrderInformation !== false ? 'mb-px' : '')}
                   dangerouslySetInnerHTML={{
                     __html: orderInformation
                   }}>
              </div>
            </If>
            <If condition={additionalOrderInformation !== false}>
              <div className="text-sm">
                {additionalOrderInformation}
              </div>
            </If>
          </div>
        </If>
      </div>
    </div>
  )
};

export default Closing;
